require("!!C:\\svn\\trunk\\node_modules\\script-loader\\addScript.js")(require("!!C:\\svn\\trunk\\node_modules\\raw-loader\\index.js!C:\\svn\\trunk\\node_modules\\babel-loader\\lib\\index.js?{\"presets\":[\"react\",\"es2015\"],\"plugins\":[\"transform-class-properties\",\"transform-object-assign\"],\"compact\":false}!C:\\svn\\trunk\\client-side\\common\\js\\jquery.ui.touch-punch.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./client-side/common/js/jquery.ui.touch-punch.min.js
// module id = 92
// module chunks = 0